define('fv-phone', ['jquery', 'validation', 'intlTelInput', 'intlTelInput_utils'], function ($) {
    FormValidation.Validator.intPhoneNumber = {
        init: function (validator, $field, options) {
            // Attach the intlTelInput on field
            $field.intlTelInput({
                utilsScript: '/assets/naviline.ru/js/intlTelInput_utils.js',
                autoPlaceholder: true,
                defaultCountry: 'auto',
                onlyCountries: ['ru'],
                allowDropdown: false,
                preferredCountries: ['ru']
            });

            // Revalidate the field when changing the country
            var $form = validator.getForm(),
                fieldName = $field.attr('data-fv-field');
            $form.on('click.country.intphonenumber', '.country-list', function () {
                $form.formValidation('revalidateField', fieldName);
            });
        },

        destroy: function (validator, $field, options) {
            $field.intlTelInput('destroy');

            // Turn off the event
            validator.getForm().off('click.country.intphonenumber');
        },

        validate: function (validator, $field, options) {
            try {
                var isValid = $field.value === '' || $field.intlTelInput('isValidNumber'),
                    err = $field.intlTelInput('getValidationError'),
                    message = null;
                switch (err) {
                    case intlTelInputUtils.validationError.INVALID_COUNTRY_CODE:
                        message = 'Код страны недопустим';
                        break;

                    case intlTelInputUtils.validationError.TOO_SHORT:
                        message = 'Номер телефона слишком короткий';
                        break;

                    case intlTelInputUtils.validationError.TOO_LONG:
                        message = 'Номер телефона слишком длинный';
                        break;

                    case intlTelInputUtils.validationError.NOT_A_NUMBER:
                        message = 'Введенное значение не является номером телефона';
                        break;

                    default:
                        message = 'Введен некорректный номер телефона';
                        break;
                }

                return {
                    valid: isValid,
                    message: message
                };
            } catch (e) {
                return {
                    valid: true,
                    message: null
                };
            }
        }
    }
});

